import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, LL_H_C, LL_V_L, TS_Input } from '@nu-art/thunderstorm-frontend/index';
import { Filter, MUSTNeverHappenException, sortArray } from '@nu-art/ts-common';
import './Renderer_AddOrder.scss';
import { FadeScrollWrapper, ICONS } from '@app/styles';
import { ModuleFE_ScrollBar } from '@app/styles/frontend/modules/ModuleFE_ScrollBar/ModuleFE_ScrollBar';
import { ModuleFE_Advisor_Action, ModuleFE_Advisor_EHRInstallation, ModuleFE_Advisor_OrderConfiguration, ModuleFE_AdvisorSession, ModuleFE_RuntimeOrder, ModuleFE_RuntimeProtocol } from '@app/advisor-frontend';
import { ModuleFE_ProtocolInteraction } from '../../../../../_enum/protocol-interaction/index.js';
import { PopUp_Confirmation } from '../../../../pop-ups/PopUp_Confirmation/PopUp_Confirmation.js';
import { ModuleFE_AdvisorAnalytics } from '../../../../../_analytics/consts.js';
import { OrderPlacedSource } from '../../../../../_analytics/types.js';
import { ModuleFE_AdvisorMini } from '../../../../../modules/ModuleFE_AdvisorMini.js';
import { PanelKey_Home } from '../../../../../_shared.js';
var OrderSortScore;
(function (OrderSortScore) {
    OrderSortScore[OrderSortScore["ExactMatch"] = 0] = "ExactMatch";
    OrderSortScore[OrderSortScore["StartsWith"] = 1] = "StartsWith";
    OrderSortScore[OrderSortScore["Includes"] = 2] = "Includes";
    OrderSortScore[OrderSortScore["Regex"] = 3] = "Regex";
})(OrderSortScore || (OrderSortScore = {}));
export class Renderer_AddOrder extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.protocolId = nextProps.protocolId;
        state.orders = this.getOrders();
        return state;
    }
    componentDidMount() {
        ModuleFE_ScrollBar.updateScrollBar(this.props.scrollRef);
    }
    //######################### Logic #########################
    getOrders() {
        const ehrInstallationId = ModuleFE_AdvisorSession.getCurrentEHRInstallationId();
        const ehrInstallation = ModuleFE_Advisor_EHRInstallation.cache.unique(ehrInstallationId);
        if (!ehrInstallationId || !ehrInstallation)
            return [];
        const ehrInstallationOrders = ModuleFE_Advisor_OrderConfiguration.cache.filter(installationOrder => installationOrder.ehrInstallationId === ehrInstallationId)
            .map(installationOrder => installationOrder.orderId);
        const orders = ModuleFE_Advisor_Action.cache.filter(order => {
            return ehrInstallationOrders.includes(order._id);
        }).map(_order => {
            const order = _order;
            if (!order.variableId && !order.wizardId)
                return { item: order, available: false };
            return { item: order, available: true };
        });
        return sortArray(orders, order => order.item.name.toLowerCase());
    }
    onOrderClick = (e, order) => {
        if (!order.available)
            return;
        //Open confirmation
        PopUp_Confirmation.show(e, {
            message: _jsxs(_Fragment, { children: ['Please confirm to proceed adding order ', _jsx("b", { children: order.item.name })] }),
            acceptButtonLabel: 'Confirm',
            onAccept: async () => {
                try {
                    const protocol = ModuleFE_RuntimeProtocol.cache.unique(this.state.protocolId);
                    if (!protocol)
                        throw new MUSTNeverHappenException(`cannot find runtime protocol with id ${this.state.protocolId}`);
                    await ModuleFE_RuntimeOrder.createOrder(order.item, protocol.pathwayId);
                    //Report analytics event
                    ModuleFE_AdvisorAnalytics.trigger.addData.addData_order_submit({
                        orderId: order.item._id,
                        orderLabel: order.item.label ?? order.item.name,
                    });
                    ModuleFE_AdvisorAnalytics.trigger.orders.order_placed({
                        orderId: order.item._id,
                        orderLabel: order.item.label ?? order.item.name,
                        source: OrderPlacedSource.addDataPanel,
                    });
                    // if enable AGL is disabled, exit
                    if (!ModuleFE_AdvisorSession.getEnableAgl())
                        return;
                    // otherwise post order for consistency
                    ModuleFE_RuntimeOrder.postEpicOrder(order.item._id);
                }
                catch (err) {
                    this.logError(`Could not send order ${order.item._id}`);
                }
                finally {
                    ModuleFE_ProtocolInteraction.closeInteraction();
                    if (ModuleFE_AdvisorMini.getIsMiniActive())
                        ModuleFE_AdvisorMini.openPanel(PanelKey_Home);
                }
            }
        });
    };
    getOrdersToRender = () => {
        const searchTerm = this.state.searchTerm?.toLowerCase();
        if (!searchTerm)
            return this.state.orders;
        const filter = new Filter(order => [order.item.name]);
        const orders = filter.filter(this.state.orders, searchTerm);
        const scoreMap = {};
        orders.forEach(order => {
            const name = order.item.name.toLowerCase();
            if (name === searchTerm)
                return scoreMap[order.item._id] = OrderSortScore.ExactMatch;
            if (name.startsWith(searchTerm))
                return scoreMap[order.item._id] = OrderSortScore.StartsWith;
            if (name.includes(searchTerm))
                return scoreMap[order.item._id] = OrderSortScore.Includes;
            scoreMap[order.item._id] = OrderSortScore.Regex;
        });
        return sortArray(orders, o => scoreMap[o.item._id]);
    };
    //######################### Render #########################
    render() {
        return _jsxs(LL_V_L, { className: 'add-order', children: [this.renderSearch(), this.renderOrders()] });
    }
    renderSearch = () => {
        return _jsxs(LL_H_C, { className: 'add-order__search', children: [_jsx(TS_Input, { type: 'text', value: this.state.searchTerm, onChange: searchTerm => this.setState({ searchTerm }) }), _jsx(ICONS.advisor_v5_search.component, {})] });
    };
    renderOrders = () => {
        const orders = this.getOrdersToRender();
        return _jsx(FadeScrollWrapper, { scrollRef: this.props.scrollRef, className: 'add-order__orders', children: orders.map(order => {
                const className = _className('add-order__order', !order.available && 'disabled');
                return _jsx("div", { className: className, onClick: e => this.onOrderClick(e, order), children: order.item.name }, order.item._id);
            }) });
    };
}
//# sourceMappingURL=Renderer_AddOrder.js.map